import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { LoaderService, RestService } from '@stdoutsrl/design-kit';
import { api } from '../../../environments/environment';

@Component({
  selector: 'app-ships',
  templateUrl: './ships.component.html',
  styles: [],
  standalone: false
})
export class ShipsComponent implements OnInit {
  constructor(
    private rest:RestService,
    private loader:LoaderService
  ){}

  baseUrl = api.baseUrl
  ships: any[] = [
  ]

  ngOnInit(): void {
    this.loader.on()
    this.rest.get('/boat').subscribe({
      next:(value:any)=> {
        this.ships = value
        this.loader.off(true)
      },
      error:(value)=> {
        this.loader.off(true)
      },
    })
  }
}
